import { render, staticRenderFns } from "./addProfile.vue?vue&type=template&id=536bb08e&scoped=true&"
import script from "./addProfile.vue?vue&type=script&lang=js&"
export * from "./addProfile.vue?vue&type=script&lang=js&"
import style0 from "./addProfile.vue?vue&type=style&index=0&id=536bb08e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536bb08e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('536bb08e')) {
      api.createRecord('536bb08e', component.options)
    } else {
      api.reload('536bb08e', component.options)
    }
    module.hot.accept("./addProfile.vue?vue&type=template&id=536bb08e&scoped=true&", function () {
      api.rerender('536bb08e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packagingManagement/components/addProfile.vue"
export default component.exports